import React from 'react';
import ApplicationListItem from './ApplicationListItem';
import { Fragment } from 'react';

export default function ResultsList({ showAdvanced, ...props }) {
  const application = props.hit;

  return (
    <Fragment>
      <ApplicationListItem
        key={props.hit.name}
        application={application}
        showAdvanced={showAdvanced}
      />
    </Fragment>
  );
}
